import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"
import { addStaticPage } from "./slice"
import i18n from "i18n"
import { API } from "api"

function* addItem({ payload: { params, onSuccess, onError } }) {
  try {
    const response = yield call(API.admin.addStaticPage, params)

    const { data } = response

    toastr.success(i18n.t("add"))

    if (onSuccess) {
      onSuccess()
    }
    yield put(addStaticPage.addCompleted())
  } catch (error) {
    const errors = error.response?.data?.errors || {}
    const message = error.response?.data?.message || i18n.t("error")

    yield put(
      addStaticPage.addRejected({
        errors,
        message,
      })
    )

    if (onError) {
      onError(errors)
    }
  }
}

export function* watchAddItem() {
  yield takeEvery(addStaticPage.add, addItem)
}

function* addSaga() {
  yield all([fork(watchAddItem)])
}

export default addSaga
